import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, fromEvent, of } from 'rxjs';
import { map, } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationDeleteService {
  click$: Observable<boolean>;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.click$ = fromEvent<MouseEvent>(document, 'click').pipe(
        map(event => {
          const target = event.target as HTMLElement;
          return target.tagName === 'A' || target.tagName === 'IMG';
        })
      );
    } else {
      // SSR: return empty observable to avoid errors
      this.click$ = of(false);
    }
  }

}
